export class AzureFreeProtectionBilling {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "purchaserEmail",
            "baseName": "purchaserEmail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureFreeProtectionBilling.attributeTypeMap;
    }
    constructor() {
    }
}
